import { render, staticRenderFns } from "./modal-renameItem.vue?vue&type=template&id=70cb824a&"
import script from "./modal-renameItem.vue?vue&type=script&lang=js&"
export * from "./modal-renameItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports